import {FilterBlock, FilterBlockType, FilterState} from "../TableFilter";
import UIListBox from "../../form/UIListBox";
import {IOption} from "../../form/UIOption";
import React from "react";

type Props = {
  data: SelectFilterBlock;
  state: FilterState
  onToggle: (data: FilterState) => void;
}

export default function UISelectFilterBlock({data, state, onToggle}: Props) {
  const {id, title, options} = data;

  const onClear = () => {
    onToggle(new FilterState(id, false, ''));
  };

  const onChange = (selectedValue: string) => {
    onToggle(new FilterState(id, true, selectedValue));
  };

  const modifiedOptions: IOption<boolean>[] = options.map(option => {
    return {
      id: option.id,
      value: option.id,
      label: option.name,
      selected: option.id === state.value
    } as IOption<boolean>
  });

  return (
    <div className="py-4 px-3">
      <div className="flex flex-row justify-between">
        <span className="font-bold">{title}</span>
        {state.active &&
          <button onClick={() => onClear()} className="ml-4 text-blue">Clear</button>
        }
      </div>
      <div className="flex flex-col mt-4">
        <UIListBox options={modifiedOptions} onChange={onChange}/>
      </div>
    </div>
  );
}

export type SelectValue = {
  id: string;
  name: string
}

export class SelectFilterBlock implements FilterBlock {
  readonly type: FilterBlockType = FilterBlockType.SELECT;

  constructor(readonly id: string, readonly title: string, readonly options: SelectValue[]) {
  }
}
